export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-background flex flex-col" id="terms">
      <main className="py-16 px-6 flex-grow">
        <div className="container max-w-4xl mx-auto prose prose-blue">
          <h1 className="text-4xl font-bold mb-8">Terms of Service</h1>
          <p className="text-muted-foreground mb-4">Last updated: 04 Feb 2025 </p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">1. Acceptance of Terms</h2>
            <p>
              By accessing or using AquaMind AI Pte.Ltd.'s' website or services (“Services”), you agree to be bound by these Terms of Service and any additional terms referenced herein. If you do not agree, please discontinue use of our Services.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">2. Services Description</h2>
            <p>Our company AquaMind AI Pte.Ltd. (“we,” “us,” “our”) offers consulting and advisory services tailored to client needs, including software development, solution integration, and technical implementation. Any specific terms, deliverables, or confidentiality obligations are typically outlined in separate agreements (e.g., NDAs or statements of work) if applicable.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">3. Intellectual Property</h2>
            <p>All materials, documents, and content we provide during the course of Services remain our intellectual property unless otherwise agreed in writing. You may not copy, distribute, or reproduce these materials without our express permission.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">4. Confidentiality</h2>
            <p>We respect the confidential information you share with us and will handle it according to standard professional practices or any specific NDA terms. Likewise, you agree to keep any non-public details about our methods, pricing, or processes confidential.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">5. Payment and Refunds</h2>
            <ul className="list-disc pl-6">
              <li><strong>Payment Terms:</strong> Payment schedules and amounts will be outlined in individual proposals or agreements.</li>
              <li><strong>Refund Policy:</strong> Refunds, if applicable, will be governed by the terms stated in your service agreement.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">6. Disclaimers and Liability</h2>
            <ul className="list-disc pl-6">
              <li><strong>No Guaranteed Outcomes:</strong> While we aim to provide valuable insights, recommendations, and technical implementations, we do not guarantee specific results or outcomes from our consulting, software development, or integration services.</li>
              <li><strong>Limited Liability:</strong> To the maximum extent allowed by law, we are not liable for indirect, incidental, or consequential damages that may arise from using our Services.</li>
              <li><strong>Professional Advice:</strong> Any advice or recommendations are based on our expertise, but the ultimate responsibility for decisions and actions remains with you.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">7. Termination</h2>
            <p>Either party may terminate the engagement if the other party materially breaches these Terms or any related agreements. Termination notices and next steps will be handled in accordance with the terms of our specific agreement.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">8. Changes to These Terms</h2>
            <p>We may update these Terms from time to time. Any changes will be effective immediately upon posting on our website. Continued use of our Services after changes become effective indicates acceptance of the updated Terms.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">9. Governing Law</h2>
            <p>These Terms are governed by the laws of Singapore. Any disputes will be resolved in the courts of Singapore.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">10. Contact Information</h2>
            <p>For questions about these Terms of Service, please contact us at:</p>
            <p>Email: <a href="mailto:legal@yourcompany.com" className="text-blue-600">legal@aquamindai.com</a></p>
          </section>
        </div>
      </main>
    </div>
  );
}
